import { render, staticRenderFns } from "./voiceAssistant.vue?vue&type=template&id=47652cf8&scoped=true"
import script from "./voiceAssistant.vue?vue&type=script&lang=ts"
export * from "./voiceAssistant.vue?vue&type=script&lang=ts"
import style0 from "./voiceAssistant.vue?vue&type=style&index=0&id=47652cf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47652cf8",
  null
  
)

export default component.exports